import { AuthEndpoint } from './Auth';
function mapAccessTimeBody(body) {
    if (body == null || typeof body !== 'object') {
        return body;
    }
    const b = body;
    return {
        ...b,
        sunriseDTTM: b.sunriseDTTM instanceof Date ? b.sunriseDTTM.getTime() : b.sunriseDTTM,
        sunsetDTTM: b.sunsetDTTM instanceof Date ? b.sunsetDTTM.getTime() : b.sunsetDTTM
    };
}
export class OrganizationEncryptionAccessTimesEndpoint extends AuthEndpoint {
    async getRequestInit(body) {
        return super.getRequestInit(mapAccessTimeBody(body));
    }
}
